import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../helper';

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one &&
  two &&
  two.year === one.year &&
  two.month === one.month &&
  two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
      ? one.month === two.month
        ? one.day === two.day ? false : one.day < two.day
        : one.month < two.month
      : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
      ? one.month === two.month
        ? one.day === two.day ? false : one.day > two.day
        : one.month > two.month
      : one.year > two.year;

export interface IPickerDateChange {
  before: string;
  after: string;
}

@Component({
  selector: 'app-datepicker-range',
  templateUrl: './datepicker-range.component.html',
  styleUrls: ['./datepicker-range.component.css']
})
export class DatepickerRangeComponent implements OnInit {
  @Output() pickerDateChange = new EventEmitter<IPickerDateChange>();
  @Output() clearInput = new EventEmitter();
  @Input() placeHolder: string;

  fromDate: NgbDateStruct;
  toDate: NgbDateStruct;
  rangePicker = false;
  hoveredDate: NgbDateStruct;
  mFromToDate: string;

  constructor(private calendar: NgbCalendar, private helper: Helper) {
    // this.fromDate = this.calendar.getToday();
    // this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 91);
  }

  ngOnInit() {
    this.emitChanges();
  }

  onDateSelection(date: NgbDateStruct) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
      this.toDate = date;
      this.rangePicker = false;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    this.emitChanges();
  }

  rangePickerToggle() {
    this.rangePicker = !this.rangePicker;
  }

  isHovered = date =>
    this.fromDate &&
    !this.toDate &&
    this.hoveredDate &&
    after(date, this.fromDate) &&
    before(date, this.hoveredDate);
  isInside = date => after(date, this.fromDate) && before(date, this.toDate);
  isFrom = date => equals(date, this.fromDate);
  isTo = date => equals(date, this.toDate);

  private emitChanges() {
    const data = {
      after: this.helper.formatDate(this.fromDate),
      before: this.helper.formatDate(this.toDate)
    };
    if (data.after && data.before) {
      this.pickerDateChange.emit(data);
      this.createDateString();
    }
  }

  private getDateString(date: NgbDateStruct): string {
    return this.helper.formatFilterDate(date, 'DD-MM-YYYY');
  }

  private createDateString() {
    this.mFromToDate =
      this.getDateString(this.fromDate) + ' ' + this.getDateString(this.toDate);
  }

  onClearInput() {
    this.mFromToDate = '';
    this.fromDate = null;
    this.toDate = null;
    this.clearInput.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker-range/datepicker-range.component.ts